/* eslint-disable */
function anonymous(it) {
  var out = '';
  var result, value = it.UrlCustomParametersJson || it.UrlCustomParameters;
  try {
    result = JSON.parse(value.replace(/&quot;/g, '"'));
  } catch (e) {
    result = value;
  }
  if (result && result.Parameters && Array.isArray(result.Parameters)) {
    for (var i = 0; i < result.Parameters.length; i++) {
      out += ' <div> <span>{_</span><span>' + result.Parameters[i].Key + '</span><span>} = </span><span>' + result.Parameters[i].Value + '</span> </div>';
    }
  } else if (typeof result == 'string') {
    out += ' <span>' + result + '</span>';
  }
  return out;
}
export default anonymous;

